/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFPrivacyCriticalTrackingTech = {
    GoogleAnalytics: 'Google Analytics',
    MetaPixel: 'Meta Pixel',
    LinkedInInsightTag: 'LinkedIn Insight Tag',
    TikTokPixel: 'TikTok Pixel',
    XPixel: 'X Pixel',
    PinterestTag: 'Pinterest Tag',
    Heap: 'Heap',
    FullStory: 'FullStory',
    MicrosoftClarity: 'Microsoft Clarity',
    Hotjar: 'Hotjar',
    HubSpot: 'HubSpot'
} as const;
export type CRSFPrivacyCriticalTrackingTech = typeof CRSFPrivacyCriticalTrackingTech[keyof typeof CRSFPrivacyCriticalTrackingTech];


export function CRSFPrivacyCriticalTrackingTechFromJSON(json: any): CRSFPrivacyCriticalTrackingTech {
    return CRSFPrivacyCriticalTrackingTechFromJSONTyped(json, false);
}

export function CRSFPrivacyCriticalTrackingTechFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPrivacyCriticalTrackingTech {
    return json as CRSFPrivacyCriticalTrackingTech;
}

export function CRSFPrivacyCriticalTrackingTechToJSON(value?: CRSFPrivacyCriticalTrackingTech | null): any {
    return value as any;
}

